// components/modals/TermsAndConditionsModal.jsx
import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import useModalHistory from '../../../hooks/useModalHistory';
/**
 * Modal for displaying and accepting terms and conditions
 */
const TermsAndConditionsModal = ({ 
  show, 
  onHide,
  onAccept
}) => {
    useModalHistory(show, onHide, 'endowment-terms-modal');

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>Terms and Conditions</Modal.Title>
      </Modal.Header>
      
      <Modal.Body className='text-white'>
        <div className="terms-content" style={{ maxHeight: '60vh', overflowY: 'auto' }}>
          <h5>Endowment Terms and Conditions</h5>
          
          <p><strong>1. Acceptance of Terms:</strong> By creating an Endowment, you agree to these terms and conditions.</p>
          
          <p><strong>2. Service Description:</strong> The Endowment Service allows you to designate digital assets (files, passwords, banking information, and blockchain credentials) to be transferred to a designated recipient.</p>
          
          <p><strong>3. User Responsibilities:</strong> You are responsible for providing accurate information, ensuring your recipient consents to receive assets, regularly reviewing your endowment, and keeping your account secure.</p>
          
          <p><strong>4. Recipient Consent:</strong> The recipient must acknowledge the Endowment before it becomes active. Recipients will receive email notification and can decline at any time.</p>
          
          <p><strong>5. Expiration and Transfer:</strong> The Endowment will expire on the date specified during creation (cannot exceed the end of account for both sender and recipient). When an Endowment expires on date chosen, an email will be sent to your designated Recipient email address at end of that day. The recipient will then have 30 days to download the files or information. After the 30 days ends, access to contents of the Endowment will no longer be available.</p>
          
          <p><strong>6. Modification and Termination:</strong> You may modify or cancel the Endowment at any time before it's activated. We reserve the right to terminate access with or without notice.</p>
          
          <p><strong>7. Privacy and Security:</strong> We respect your privacy and handle all information securely. All assets are encrypted and accessible only to you and your designated recipient upon activation.</p>
          
          <p><strong>8. Liability Limitations:</strong> We are not liable for: inaccurate information you provide, unauthorized access due to your security failures, disputes with recipients, misuse of inherited data, or any loss/damage from using the Service.</p>
          
          <p><strong>9. Changes to Terms:</strong> We may modify these terms at any time. Continued use after notification constitutes acceptance of new terms.</p>
          
          <p><strong>10. Contact:</strong> Questions? Contact us at support@phenixloc.com.</p>
        </div>
      </Modal.Body>
      
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
        <Button variant="primary" onClick={onAccept}>
          Accept Terms
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default TermsAndConditionsModal;